import moment from 'moment-timezone'

export const getMomentInCommunityTimezone = (currentMoment, communityTimezone, format) => {
  const currentTimeDate = currentMoment.format(format)
  return moment.tz(currentTimeDate, communityTimezone)
}

export const getMomentInCommunityTimezoneReversed = (currentMoment, communityTimezone, format) => {
  const currentTimeDate = currentMoment?.tz(communityTimezone).format(format)
  return moment(currentTimeDate)
}

const formatDate = (date, timezone) => moment(date).tz(timezone).format('ll')

export const formatDates = (startDate, endDate, timezone) =>
  `${formatDate(startDate, timezone)} - ${formatDate(endDate, timezone)}`

export const formatSessionTimeRange = (start, end, timezone) =>
  `${moment(start).tz(timezone).format('hh:mm a')} - ${moment(end).tz(timezone).format('hh:mm a')}`

export const formatDayTime = (date, timezone) => ({
  tKey: 'common.dayAtTime',
  values: {
    day: moment(date).tz(timezone).format('dddd'),
    time: moment(date).tz(timezone).format('hA'),
  },
})

/**
 * Calculates the time spent by a community in the network as the largest whole time unit (years, months, or days).
 * @param date - The entry date into the network.
 * @returns {{period: 'year'|'month'|'day', count: number}} - The largest whole unit and its count. The caller
 *   renders the localized full phrase (communityLanding.details.timeInNetwork.<period>, with `_one`/`_other`).
 */
export const getCommunityTimeInNetwork = (date) => {
  const momentDate = moment(date)
  const now = moment()
  const diff = now.diff(momentDate, 'seconds')

  const duration = moment.duration(diff, 'seconds')

  if (duration.years() > 0) {
    return { period: 'year', count: duration.years() }
  } else if (duration.months() > 0) {
    return { period: 'month', count: duration.months() }
  } else {
    return { period: 'day', count: duration.days() }
  }
}

export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const DATE_FORMAT = 'YYYY-MM-DD'
